/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    PAID: 'paid',
    NOT_PAID: 'notPaid',
    WAITING_FOR_PAYMENT: 'waiting',
    STORNO: 'storno',
    BLOCKED: 'blocked', // clients in waitlist for credit and pass
    WAITLIST_STORNO: 'waitlist_storno', // clients in waitlist - storno
};
